import { AppState } from '../reducers';

export const getSnackbarState = (state: AppState) => state.snackbar;